if (!customElements.get('card-swatches')) {
  customElements.define('card-swatches', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.track = this.querySelector('.ccs__track');
      this.arr = this.querySelector('.ccs__arr');
      this.card = this.closest('.card-wrapper, .lvx__card');
      this.img = this.card ? this.card.querySelector('.card__media img, .lvx__img img') : null;
      if (this.img) {
        this.orig = { src: this.img.getAttribute('src'), srcset: this.img.getAttribute('srcset') || '' };
      }
      this.querySelectorAll('.ccs__sw').forEach((a) => {
        a.addEventListener('mouseenter', () => this.show(a));
        a.addEventListener('focus', () => this.show(a));
      });
      this.addEventListener('mouseleave', () => this.reset());
      if (this.arr && this.track) {
        this.arr.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.track.scrollBy({ left: this.track.clientWidth * 0.7, behavior: 'smooth' });
        });
        this.track.addEventListener('scroll', () => this.check(), { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(() => this.check()).observe(this);
        this.check();
      }
    }
    check() {
      const t = this.track;
      this.classList.remove('is-over');
      const over = t.scrollWidth > t.clientWidth + 2;
      this.classList.toggle('is-over', over);
      this.classList.toggle('is-end', t.scrollLeft + t.clientWidth >= t.scrollWidth - 2);
    }
    show(a) {
      if (!this.img || !a.dataset.src) return;
      this.card.classList.add('ccs-active');
      this.img.setAttribute('srcset', a.dataset.srcset || '');
      this.img.setAttribute('src', a.dataset.src);
    }
    reset() {
      if (!this.img || !this.orig) return;
      this.card.classList.remove('ccs-active');
      this.img.setAttribute('srcset', this.orig.srcset);
      this.img.setAttribute('src', this.orig.src);
    }
  });
}
